import React from "react";

export function IconTab({name, fs="fs-5"}){
    return <i className={`bi bi-${name} ${fs}`}/>
}

export function IconHelp({name, fs="fs-1"}){
    return <i className={`bi bi-${name} ${fs}`}/>
}

export function IconDropdown({name, fs="fs-6"}){
    return <i className={`bi bi-${name} ${fs}`}/>
}

export function IconFooter({name, fs="fs-6"}){
    return <i className={`bi bi-${name} ${fs}`}/>
}


